export const italian = {
  common: {
    valueTooHigh: 'Il valore non può superare',
    valueTooLow: 'Il valore deve essere almeno',
    minLengthNew: 'La lunghezza minima è',
    maxLengthNew: 'La lunghezza massima è',
    invalidFormat: 'Formato non valido',
    lbl_email: 'E-mail',
    placeholder_email: 'Inserisci qui la tua e-mail',
    lbl_password: 'Password',
    placeholder_password: 'Inserisci qui la tua password',
    text_forget_password: 'Password dimenticata',
    placeholder_write_here: 'Scrivi qui...',
    button_next: 'AVANTI',
    button_skip: 'SALTA',
    placeholder_options: 'Seleziona...',
    placeholder_enter_value: 'Inserisci valore',
    lbl_business_sector: "Settore d'attività",
    business_sector_option_trade: 'Commercio',
    business_sector_option_commerce: 'Commercio',
    business_sector_option_industry: 'Industria',
    business_sector_option_manufacturing: 'Manifatturiero',
    business_sector_option_craft_artisanal: 'Artigianato',
    business_sector_option_agriculture: 'Agricoltura',
    business_sector_option_construction: 'Edilizia',
    business_sector_option_transport_logistics: 'Trasporti e Logistica',
    business_sector_option_energy_utilities: 'Energia e Utilities',
    business_sector_option_ict_software: 'ICT e Software',
    business_sector_option_finance_insurance: 'Finanza e Assicurazioni',
    business_sector_option_healthcare_personal_services:
      'Sanità e Servizi alla Persona',
    business_sector_option_education_training: 'Istruzione e Formazione',
    business_sector_option_tourism_hospitality: 'Turismo e Ristorazione',
    business_sector_option_real_estate: 'Immobiliare',
    business_sector_option_public_administration: 'Pubblica Amministrazione',
    business_sector_option_other: 'Altro',
    business_sector_option_services: 'Servizi',
    lbl_company_name: 'Nome azienda',
    lbl_vat_number: 'Partita IVA',
    lbl_address: 'Indirizzo',
    lbl_street: 'Via / Indirizzo',
    lbl_postal_code: 'CAP',
    lbl_city: 'Città',
    lbl_province: 'Provincia',
    lbl_pec: 'PEC',
    lbl_sdi_code: 'Codice SDI (opzionale)',
    button_report: 'REPORT',
    button_close: 'CHIUDI',
    lbl_name: 'Nome',
    lbl_surname: 'Cognome',
    lbl_phone_number: 'Numero di telefono',
    lbl_company_role: 'Ruolo aziendale',
    company_role_option_consultant: 'Consulente',
    lbl_no_of_employees: 'Numero di dipendenti',
    button_return: 'Modifica',
    button_edit: 'Modifica',
    profile: 'Profilo',
    loading: 'Caricamento',
    required: 'necessario',
    recommended: 'consigliato',
    country: 'Paese',
    back: 'Torna alla piattaforma',
    jan: 'Gennaio',
    feb: 'Febbraio',
    mar: 'Marzo',
    apr: 'Aprile',
    may: 'Maggio',
    jun: 'Giugno',
    jul: 'Luglio',
    aug: 'Agosto',
    sep: 'Settembre',
    oct: 'Ottobre',
    nov: 'Novembre',
    dec: 'Dicembre',
    annual: 'Annuale',
    isInvalid: 'non è valido',
    isRequired: 'è obbligatorio',
    minLength: ' Numero di telefono non valido',
    maxLength: 'Limite superato',
    passwordMismatch: 'Le password non corrispondono',
    subscribe: 'ISCRIVITI',
    noData: 'Nessun Calcolo',
    stas: 'Tipologia di piano di abbonamento e servizi',
    cttop: 'Scegli la tipologia di abbonamento più adatta alle tue esigenze',
    mp: 'piani mensili',
    ap: 'piani annuali',
    ss: 'Iscrizione avvenuta con successo',
    su: 'Iscrizione non riuscita',
    profileUpdated: 'Profilo aggiornato con successo',
    profileUpdateFailed: 'Aggiornamento del profilo non riuscito',
    sp: 'Piano sottoscritto',
    a: 'Attivo',
    so: 'Iscritto il',
    cancelSubscription: 'Annulla abbonamento',
    cancelSubscriptionConfirm:
      'Sei sicuro di voler annullare il tuo abbonamento?',
    cancelSubscriptionWarning:
      "Il tuo abbonamento rimarrà attivo fino alla fine del periodo di fatturazione corrente. Dopo di che, l'accesso verrà disattivato.",
    subscriptionCancelled: 'Abbonamento annullato con successo',
    cancel: 'Annulla',
    confirm: 'Conferma',
    billingCycle: 'Ciclo di fatturazione',
    monthly: 'Mensile',
    yearly: 'Annuale',
    validUntil: 'Valido fino al',
    cancelSubscriptionError: "Impossibile annullare l'abbonamento. Riprova.",
    na: "Il piano attivo non consente l'allenamento",
    login_required: 'Effettua il login per continuare',
    usertype_option_food_beverage: 'Produzione Alimentare e Bevande',
    usertype_option_chemical_pharma: 'Chimico / Farmaceutico',
    usertype_option_automotive: 'Automobilistico',
    usertype_option_plastics_rubber: 'Plastica e Gomma',
    usertype_option_metal_fabrication:
      'Fabbricazione Metallurgica / Lavorazione Metalli',
    usertype_option_electronics: 'Elettronica / Semiconduttori',
    usertype_option_textile_apparel: 'Tessile e Abbigliamento',
    usertype_option_packaging: 'Imballaggio',
    usertype_option_logistics: 'Logistica / Magazzinaggio',
    usertype_option_other_custom: 'Altro (specificare)',
    otherBusinessSector: 'Specifica settore business',
    otherBusinessSectorPlaceHolder: 'Inserisci il tuo settore business',
    calculation: 'Calcolo',
  },
  login: {
    heading: 'Bentornato',
    sub_dont_have_account: 'Non hai un account?',
    sub_dont_have_account_s: 'Creane uno adesso.',
    button_login: 'Accedi',
    remember_password: 'Ricorda la password',
    resent: 'OTP inviata! Controlla la tua casella di posta.',
  },
  forgot_password: {
    heading: 'Password Dimenticata',
    subheading:
      'Inserisci il tuo indirizzo email per ricevere il codice di verifica.',
    button_send_code: 'INVIA CODICE',
    button_back_to_login: 'Torna al login',
  },
  register: {
    heading: 'Benvenuto',
    sub_already_have_account: 'Hai già un account?',
    sub_already_have_account_s: 'Accedi al portale.',
    lbl_usertype: 'Tipo utente',
    placeholder_usertype: 'Seleziona tipo utente',
    usertype_option_company: 'Azienda',
    usertype_option_consultant: 'Consulente',
    lbl_repeat_password: 'Conferma password',
    button_create: 'CREA NUOVO ACCOUNT',
    usertype_option_site_director: 'Direttore di Stabilimento',
    usertype_option_environmental_manager: 'Responsabile Ambientale',
    usertype_option_hse_officer: 'Responsabile HSE',
    usertype_option_production_supervisor: 'Capo Reparto Produzione',
    usertype_option_quality_manager: 'Responsabile Qualità',
    usertype_option_maintenance_lead: 'Responsabile Manutenzione',
    usertype_option_supply_chain_coordinator: 'Coordinatore Supply Chain',
  },
  register_confirm_otp: {
    heading: "Ti abbiamo inviato un'e-mail",
    subheading:
      'Il tuo codice sta arrivando. Per accedere, inseriscilo non appena lo ricevi via email. Potrebbero volerci alcuni minuti.',
    lbl_confirmation_code: 'Codice di conferma',
    button_confirm: 'Conferma',
    button_resend_code: 'Reinvia codice',
  },
  inform_step_1: {
    heading: 'FASE 1',
    subheading: 'Informazioni profilo',
  },
  inform_step_2: {
    heading: 'FASE 2',
    subheading: 'Informazioni aziendali',
  },
  inform_step_3: {
    heading: 'FASE 3',
    subheading: 'Informazioni abbonamento',
    info_title: 'Congratulazioni, ora hai 2 video disponibili nel tuo profilo.',
    info_subtitle:
      'In questa fase, hai accesso a due strumenti preziosi per iniziare a utilizzare al meglio il software! Entrambi i contenuti sono disponibili nella tua area personale e puoi consultarli quando ne hai bisogno. Prenditi il tempo per esaminare i materiali e acquisire le competenze che ti aiuteranno a sfruttare al meglio il nostro software.',
    button_play_now: 'RIPRODUCI ORA',
    button_confirm: 'CONFERMA',
  },
  dashboard: {
    header_carbon_footprint: 'Impronta di Carbonio',
    header_emissions: 'Coinvolgimento Stakeholder',
    header_profile: 'Profilo',
    sidebar_favorites: 'Preferiti',
    sidebar_no_favorites: 'Nessuna azienda preferita',
    sidebar_companies: 'Aziende',
    sidebar_no_companies: 'Nessuna azienda aggiunta',
    button_new_company: 'NUOVA AZIENDA',
    training: 'Formazione',
  },
  form_company_registration: {
    heading: 'Registrazione Azienda',
    subheading:
      "Qui puoi aggiungere aziende per le quali vuoi calcolare l'impronta di carbonio e gestire i relativi dati. Per iniziare, compila i campi richiesti. Le aziende aggiunte saranno visualizzate nell'elenco a sinistra, con il nome e il logo dell'azienda.",
    lbl_company_type: 'Tipo di azienda',
    placeholder_company_type: 'Seleziona un tipo di azienda',
    company_type_option1: 'Individuale',
    company_type_option2: 'Persona Giuridica',
    placeholder_business_sector: "Seleziona un settore d'attività",
    lbl_contact_phone: 'Telefono di contatto',
    lbl_contact_email: 'Email di contatto',
    lbl_company_logo: 'Logo Aziendale',
    button_upload: 'CARICA',
    button_add_now: 'AGGIUNGI ORA',
  },
  profile: {
    heading_video_available: 'Video disponibili',
    subheading_video_available:
      'Prenditi il tempo per esaminare i materiali e acquisire le competenze che ti aiuteranno a sfruttare al meglio il nostro software.',
    heading_profile_info: 'Informazioni profilo',
    subheading_profile_info:
      'Qui puoi aggiungere e modificare le tue informazioni e trovare contenuti dedicati a te.',
    button_save: 'SALVA',
  },
  company_item: {
    heading: 'Dai un nome al tuo calcolo',
    subheading:
      "Inizia dando un nome al tuo nuovo calcolo dell'impronta di carbonio. Questo nome ti aiuterà a identificare facilmente il tuo report tra quelli esistenti. Ad esempio, puoi utilizzare il nome dell'azienda seguito dall'anno o dal trimestre di riferimento, come 'AziendaXYZ Calcolo Q3 2024'.",
    lbl_calculation_name: 'Nome del calcolo',
    placeholder_calculation_name: 'Inserisci nome del calcolo',
    button_start_calculation: 'INIZIA CALCOLO',
    table_heading: 'Calcoli attivi',
    table_subheading:
      'Dopo aver risposto alle domande per ogni categoria, puoi confermare il calcolo per salvarlo in questa tabella dei report. Puoi modificarlo successivamente se necessario.',
    table_col_name: 'Nome del calcolo',
    table_col_date: 'Data di inizio',
    table_col_category: 'Categoria',
    table_col_completion: 'Completamento',
    table_col_status: 'Azioni disponibili',
    table_col_action: 'Disponibili',
  },
  carbon: {
    heading: 'Compilazione delle categorie di emissioni',
    subheading:
      "Il calcolo dell'impronta di carbonio si basa sull'analisi delle tre categorie definite dal Protocollo GHG (Greenhouse Gas Protocol). Rispondere alle seguenti domande ti permetterà di completare il profilo delle emissioni della tua azienda",
    subpoint1: 'Categoria 1, Emissioni dirette',
    subpoint1_data:
      "Emissioni dirette: Sono emissioni generate direttamente dalle attività dell'azienda, come il consumo di carburante nei veicoli aziendali o l'utilizzo di caldaie.",
    subpoint2: 'Categoria 2, Emissioni indirette',
    subpoint2_data:
      "Include le emissioni derivanti dal consumo di elettricità, riscaldamento o raffreddamento acquistati dall'azienda.",
    subpoint3: 'Categoria 3, 4, 5, 6, Altre emissioni indirette',
    subpoint3_data:
      "Questo ambito include le emissioni dell'intera catena di approvvigionamento, come i viaggi d'affari, l'approvvigionamento di materie prime o la gestione dei rifiuti.",
  },
  emission: {
    heading: 'Coinvolgimento Stakeholder',
    subheading:
      "Monitora il progresso delle aziende che hai invitato a calcolare la loro impronta di carbonio. Segui il percorso di ogni stakeholder dall'invito al completamento.",
    associated_companies: 'Stakeholder Invitati',
    associated_companies_desc:
      'Visualizza e gestisci le aziende invitate a calcolare la loro impronta di carbonio',
    generate_invite: 'Genera Link di Invito',
    invite_link_generated: 'Link di invito generato!',
    copy_link: 'Copia Link',
    link_copied: 'Link copiato negli appunti!',
    link_expires: 'Questo link scade tra 7 giorni',
    link_never_expires: 'Questo link è permanente e non scade mai',
    no_linked_companies: 'Nessuno stakeholder invitato',
    no_linked_companies_desc:
      "Invia un invito alle aziende che vuoi coinvolgere nel calcolo dell'impronta di carbonio.",
    company_name: 'Azienda / Email',
    status: 'Stato',
    actions: 'Azioni',
    status_invited: 'Invitato',
    status_registered: 'Registrato',
    status_started: 'Iniziato',
    status_completed: 'Completato',
    status_accepted: 'Registrato',
    remove: 'Rimuovi',
    remove_confirm: 'Sei sicuro di voler rimuovere questo stakeholder?',
    invite_title: 'Sei stato invitato!',
    invite_desc:
      "ti ha invitato a calcolare l'impronta di carbonio della tua azienda.",
    accept_invite: 'Accetta Invito',
    select_company: 'Seleziona Azienda',
    select_company_desc: "Scegli quale azienda collegare all'invitante",
    invite_accepted: 'Invito accettato con successo!',
    invite_expired: 'Questo link di invito è scaduto',
    invite_invalid: 'Link di invito non valido',
    login_to_accept: 'Effettua il login per accettare questo invito',
    create_account_first: 'Crea un account per accettare questo invito',
    invite_company: 'Invita Azienda',
    invite_company_desc: "Invia un invito a un'azienda",
    invitee_email: 'Indirizzo Email Invitato',
    send_invite: 'Invia Invito',
    invite_sent: 'Invito inviato con successo!',
    invite_error: 'Invio invito fallito. Riprova.',
    your_invite_link: 'Il Tuo Link di Invito',
    your_invite_link_desc:
      "Condividi questo link con le aziende che vuoi invitare per il calcolo dell'impronta di carbonio",
    generate_new_link: 'Genera Nuovo Link',
    email_column: 'Email',
    invite_date: 'Data Invito',
    last_activity: 'Ultima Attività',
    total_invited: 'Invitati',
    total_registered: 'Registrati',
    total_started: 'Iniziati',
    total_completed: 'Completati',
    total: 'Totale',
  },

  category: {
    heading_category: 'Categoria',
    subheading_category: 'Domanda',
    subheading_category_s: 'di',
    category_doubts: 'Dubbi',
    category_info: 'Info',
    info_category: 'Categoria',
    info_name: 'Nome',
    info_region: 'Regione',
    info_source: 'Fonte',
    info_source_dataset: 'Dataset di origine',
    heading_steps_completed: 'Fase completata!',
    subheading_steps_completed:
      'Hai risposto a tutte le domande in questa sezione. Per continuare alla fase successiva, clicca sulla freccia. Guarda le emissioni della tua azienda, già a questo punto del report.',
    heading_questionnaire_summary: 'Riepilogo del questionario',
    subheading_questionnaire_summary:
      'Scorri tutte le domande o cerca quelle che desideri visualizzare.',
    button_edit: 'MODIFICA',
    heading_summary: 'Riepilogo',
  },
  report: {
    set_in_report: 'Imposta nel report',
    remove_from_report: 'Rimuovi dal report',
    company_logo: 'Azienda',
    profile_logo: 'Profilo',
    customised_report: 'Report personalizzato con il tuo logo: €50 + IVA',
    download_report: 'Scarica il report su richiesta: €250 + IVA',
    preview_report: 'Anteprima Report',
    generate_report: 'Generare Report',
    index: 'Indice',
    back: 'Indietro',
    download: 'Scarica report',
    emission_reduction: 'Attività di mitigazione',
    save: 'Salva',
    cancel: 'Annulla',
    methodological_approach: 'Approccio metodologico',
    introduction: 'Introduzione',
    company_profile: 'Profilo aziendale',
    mission: 'Missione',
    vision: 'Visione',
    purpose_scope: 'Scopo e ambito',
    regulatory_references: 'Riferimenti normativi',
    ghg_boundaries: "Confini dell'inventario GHG",
    organizational_boundaries: 'Confini organizzativi',
    reporting_boundaries: 'Confini di rendicontazione',
    categorization: 'Categorizzazione delle emissioni GHG dirette e indirette',
    principles_adopted: 'Principi adottati',
    reporting_phases: 'Fasi di rendicontazione GHG',
    significance_definition:
      'Definizione della significatività delle emissioni GHG',
    ghg_quantification: 'Quantificazione delle emissioni GHG',
    quantification_approach: "Scelta dell'approccio di quantificazione",
    topics_reported: 'Argomenti rendicontati',
    category_1:
      'Categoria 1 – Emissioni dirette (combustione stazionaria e mobile)',
    category_2: 'Categoria 2 – Emissioni indirette da energia importata',
    category_3: 'Categoria 3 – Altre emissioni indirette (trasporti e viaggi)',
    category_4: 'Categoria 4 – Beni acquistati, rifiuti e asset in leasing',
    category_5: 'Categoria 5 – Emissioni downstream e impatti dei prodotti',
    category_6: 'Categoria 6 – Altre emissioni indirette',
    total_emissions: 'Emissioni totali',
    results_comment: 'Commento sui risultati',
    uncertainty_evaluation: 'Gestione della qualità dell’inventario GHG',
    reduction_activities: 'Attività di riduzione',
    carbon_offsetting:
      'Attività di compensazione del carbonio: un albero per il futuro',
    quality_management: 'Ruolo dell’organizzazione nell’attività di verifica',
    verification_role: 'Attività di mitigazione',
    glossary: 'Glossario',
  },
  close: {
    heading: 'Sei sicuro di voler uscire?',
    logout_message: 'Sei sicuro di voler uscire dal tuo account?',
    subheading:
      'Abbiamo salvato automaticamente i tuoi progressi fino a questo punto.',
    subheading1:
      'Puoi riprendere il calcolo della tua impronta di carbonio in qualsiasi momento accedendo alla tabella iniziale, dove troverai il calcolo parzialmente completato.',
    subheading2:
      'Vuoi continuare a modificare il calcolo o chiudere e salvare i risultati correnti?',
    button_yes: 'CHIUDI E SALVA',
    button_no: 'CONTINUA CON LA MODIFICA',
    yes: 'SÌ',
    no: 'NO',
  },
  paused: {
    heading: 'Carbon Footprint Pro è temporaneamente in pausa',
    body: 'Il servizio è momentaneamente sospeso: durante questo periodo non è possibile accedere alla piattaforma né registrare nuovi account.',
    thanks: 'Ci scusiamo per il disagio e ti ringraziamo per la comprensione.',
  },
};
